import { createAsyncThunk } from "@reduxjs/toolkit";
import { specificationService } from "@/shared/services/api/specification-service";
import {
  IGetSpecificationDetailRequest,
  IGetSpecificationPinnedProductsRequest,
  IGetSpecificationScoredProductsRequest,
  IGetSpecificationCandidateProductsRequest,
  IGetSpecificationContributorsRequest,
  IGetSupplierResponseDetailsRequest,
  IGetSupplierStatisticsRequest,
  IGetConflictingItemsRequest,
  IGetSpecificationProductStatsRequest,
  IGetNotFoundItemsRequest,
  IGetScreenTimeStatsRequest,
  IGetSpecificationCreditStatsRequest,
} from "@/shared/services/interface/requests/IReportRequest";

export const getSpecificationDetailThunk = createAsyncThunk(
  "report/getSpecificationDetail",
  async (payload: IGetSpecificationDetailRequest, thunkAPI) => {
    try {
      const response = await specificationService.getSpecificationDetail(
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Bir hata oluştu"
      );
    }
  }
);

export const getSpecificationItemStatsThunk = createAsyncThunk(
  "report/getSpecificationItemStats",
  async (payload: IGetSpecificationDetailRequest, thunkAPI) => {
    try {
      const response = await specificationService.getSpecificationItemStats(
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Bir hata oluştu"
      );
    }
  }
);

export const getSpecificationPinnedProductsThunk = createAsyncThunk(
  "report/getSpecificationPinnedProducts",
  async (payload: IGetSpecificationPinnedProductsRequest, thunkAPI) => {
    try {
      const response =
        await specificationService.getSpecificationPinnedProducts(payload);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Bir hata oluştu"
      );
    }
  }
);

export const getSpecificationScoredProductsThunk = createAsyncThunk(
  "report/getSpecificationScoredProducts",
  async (payload: IGetSpecificationScoredProductsRequest, thunkAPI) => {
    try {
      const response =
        await specificationService.getSpecificationScoredProducts(payload);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Bir hata oluştu"
      );
    }
  }
);

export const getSpecificationCandidateProductsThunk = createAsyncThunk(
  "report/getSpecificationCandidateProducts",
  async (payload: IGetSpecificationCandidateProductsRequest, thunkAPI) => {
    try {
      const response =
        await specificationService.getSpecificationCandidateProducts(payload);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Bir hata oluştu"
      );
    }
  }
);

export const getSpecificationContributorsThunk = createAsyncThunk(
  "report/getSpecificationContributors",
  async (payload: IGetSpecificationContributorsRequest, thunkAPI) => {
    try {
      const response = await specificationService.getSpecificationContributors(
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Bir hata oluştu"
      );
    }
  }
);

export const getSupplierResponseDetailsThunk = createAsyncThunk(
  "report/getSupplierResponseDetails",
  async (payload: IGetSupplierResponseDetailsRequest, thunkAPI) => {
    try {
      const response = await specificationService.getSupplierResponseDetails(
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Bir hata oluştu"
      );
    }
  }
);

export const getSupplierStatisticsThunk = createAsyncThunk(
  "report/getSupplierStatistics",
  async (payload: IGetSupplierStatisticsRequest, thunkAPI) => {
    try {
      const response = await specificationService.getSupplierStatistics(
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Bir hata oluştu"
      );
    }
  }
);

export const getSpecificationScreenTimeStatsThunk = createAsyncThunk(
  "report/getSpecificationScreenTimeStats",
  async (payload: IGetScreenTimeStatsRequest, thunkAPI) => {
    try {
      const response =
        await specificationService.getSpecificationScreenTimeStats(payload);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Bir hata oluştu"
      );
    }
  }
);

export const getConflictingItemsThunk = createAsyncThunk(
  "report/getConflictingItems",
  async (payload: IGetConflictingItemsRequest, thunkAPI) => {
    try {
      const response = await specificationService.getConflictingItems(payload);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Bir hata oluştu"
      );
    }
  }
);

export const getSpecificationProductStatsThunk = createAsyncThunk(
  "report/getSpecificationProductStats",
  async (payload: IGetSpecificationProductStatsRequest, thunkAPI) => {
    try {
      const response = await specificationService.getSpecificationProductStats(
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Bir hata oluştu"
      );
    }
  }
);

export const getNotFoundItemsThunk = createAsyncThunk(
  "report/getNotFoundItems",
  async (payload: IGetNotFoundItemsRequest, thunkAPI) => {
    try {
      const response = await specificationService.getNotFoundItems(payload);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Bir hata oluştu"
      );
    }
  }
);

export const getSpecificationCreditStatsThunk = createAsyncThunk(
  "report/getSpecificationCreditStats",
  async (payload: IGetSpecificationCreditStatsRequest, thunkAPI) => {
    try {
      const response =
        await specificationService.getSpecificationCreditStats(payload);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Bir hata oluştu"
      );
    }
  }
);
